import React, { useState } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-transparent pt-14 sm:pt-12 lg:pt-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo - Using provided high quality logo */}
          <a href="/" className="flex items-center" data-testid="header-logo">
            <img 
              src="/buildpilot-logo.avif"
              alt="BuildPilot App Logo - Australia's Building Companion"
              className="h-[30px] w-auto"
            />
          </a>

          {/* Navigation tabs */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            <a 
              href="/guides" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-guides"
            >
              Guides
            </a>
            <a 
              href="/tools" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-tools"
            >
              Tools
            </a>
            <a 
              href="/blog" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-blog"
            >
              Blog
            </a>
            <a 
              href="/community" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-community"
            >
              Community
            </a>
            <a 
              href="/about" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-about"
            >
              About
            </a>
            <a 
              href="/advertise" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-advertise"
            >
              Advertise with us
            </a>
            <a 
              href="#download" 
              className="text-white/90 hover:text-white text-sm lg:text-base font-medium transition-colors"
              data-testid="nav-download"
            >
              Download
            </a>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden w-9 h-9 rounded-full border border-white/40 flex items-center justify-center text-white hover:bg-white/10 transition-colors"
            data-testid="header-menu-btn"
            aria-label="Toggle menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="4" y1="18" x2="20" y2="18" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu - Full screen overlay */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 bg-black/95 backdrop-blur-md md:hidden z-[55]">
            {/* Header area matching original header positioning */}
            <div className="pt-14 px-4 sm:px-6">
              <div className="flex items-center justify-between h-16">
                <a href="/" className="flex items-center">
                  <img 
                    src="/buildpilot-logo.avif"
                    alt="BuildPilot App Logo"
                    className="h-[30px] w-auto"
                  />
                </a>
                <button 
                  className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center text-white hover:bg-white/10 transition-colors"
                  aria-label="Close menu"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>
            <nav className="flex flex-col items-center justify-center gap-8 pt-12">
              <a 
                href="/guides" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Guides
              </a>
              <a 
                href="/tools" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Tools
              </a>
              <a 
                href="/blog" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </a>
              <a 
                href="/community" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Community
              </a>
              <a 
                href="/about" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </a>
              <a 
                href="/advertise" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Advertise with us
              </a>
              <a 
                href="#download" 
                className="text-white text-2xl font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Download
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
